var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
let ThicknessSelect = class ThicknessSelect extends Vue {
    input(value) {
        return value;
    }
    isValid(value) { return value.invalid === undefined || value.invalid === ""; }
    onChange(event) {
        const index = event.target.selectedIndex;
        return this.input(this.thicknessConfig[index].number);
    }
    get invalid() { return !this.isValid(this.selectedValue); }
};
__decorate([
    Prop({ required: true })
], ThicknessSelect.prototype, "disabled", void 0);
__decorate([
    Prop({ required: true })
], ThicknessSelect.prototype, "thicknessConfig", void 0);
__decorate([
    Prop({ required: true })
], ThicknessSelect.prototype, "selectedValue", void 0);
__decorate([
    Inject()
], ThicknessSelect.prototype, "i18n", void 0);
__decorate([
    Emit()
], ThicknessSelect.prototype, "input", null);
ThicknessSelect = __decorate([
    Component({
        components: {},
        name: "ThicknessSelect",
    })
], ThicknessSelect);
export default ThicknessSelect;
